export default "__VITE_ASSET__BJMTqvIZ__"